<template>
  <div class="profile-header">
    <div class="avatar">
      <Avatar :src="currentUser.photoURL || defaultAvatar" />
    </div>
    <div class="info">
      <span class="display-name-header">{{ currentUser.displayName }}</span>
      <br />
      <span>Biology Master</span>
    </div>
    <SplitButton label="Save" icon="pi pi-plus" :model="items"></SplitButton>
  </div>
</template>
<script lang="ts">
import { Options } from "vue-class-component";
import Base from "./../base/Base.vue";
import AuthService from "../../services/auth.service";
import { ScreenType } from "../../enum/screen.type";
@Options({})
export default class ProfileHeader extends Base {
  items = [
    {
      label: "Account",
      icon: "pi pi-user",
      command: () => {
        this.redirectTo(ScreenType.profile);
      }
    },
    {
      label: "Logout",
      icon: "pi pi-sign-out",
      command: () => {
        AuthService.signOut();
      }
    }
  ];
}
</script>

<style lang="scss">
.profile-header:hover {
  background: #f2f2f2;
}
.profile-header {
  display: flex;
  align-items: center;
  border-radius: 24px;
  color: $text-color-content;
  height: 50px;
  .avatar {
    width: 35px;
    height: 35px;
    margin-top: -5px;
    margin-right: 20px;
    cursor: pointer;
  }
  .display-name-header {
    font-weight: bold;
  }
  .p-splitbutton .p-splitbutton-defaultbutton {
    display: none;
  }
  .p-splitbutton-menubutton {
    background: transparent;
    color: #3a0000;
    border-radius: 24px;
  }
  .p-splitbutton-menubutton:hover {
    background: #f2f2f2;
    color: #3a0000;
  }
  .p-button:enabled:focus {
    background: #f2f2f2;
  }
}
</style>
